const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '专为移动端优化的纵向滚动阅读体验，无需翻页，手指轻滑即可畅享丝滑漫画之旅，沉浸感十足。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量漫画库',
    desc: '收录超过十万部韩漫、日漫、国漫作品，类型覆盖热血、恋爱、悬疑、奇幻，总有一部适合你。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日实时更新',
    desc: '热门连载漫画每日准时更新，追更不等待，最新章节第一时间推送到你面前，绝不错过精彩剧情。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '全本免费畅读',
    desc: '无需注册、无需付费，所有漫画全本完整版免费开放阅读，随时随地打开亲亲漫画即可畅享。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              为什么选择亲亲漫画
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              以读者体验为核心，打造最便捷、最丰富的免费漫画阅读平台
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {features.map((feature, i) => (
              <div
                key={i}
                className="group bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-300 transition-all"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2.5">{feature.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}